export enum Profession {
    doctor = 'doctor',
    nurse = 'nurse',
    pharmacist = 'pharmacist'
}
